module.exports = {
    NEW: 'NEW',
    EDIT: 'EDIT',
    CANCEL: 'CANCEL',
    DELETE: 'DELETE',
    SAVE: 'SAVE',
    CLOCK: 'CLOCK',
    CLEAR: 'CLEAR',
    UPLOAD: 'UPLOAD',
    DOWNLOAD: 'DOWNLOAD',
    SOUND: 'SOUND',
    OTHER: 'OTHER',
    REFRESH: 'REFRESH',
    DATA_BANK_STATUS: 'DATA_BANK_STATUS',
}